import React from 'react';
import { useTranslation } from 'react-i18next';
import { CHANGELOG } from '@/data/changelog';

const UpdatesPage = () => {
  const { t } = useTranslation();
  const items = [...CHANGELOG].sort((a,b)=> b.number - a.number);
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-xl font-semibold mb-4">{t('updates.title')}</h1>
      <p className="text-sm text-muted-foreground mb-6">{t('updates.desc')}</p>
      <div className="space-y-4">
        {items.map((it) => (
          <div key={it.number} className="bg-background border rounded p-4">
            <div className="flex items-center justify-between mb-1">
              <div className="font-semibold">#{it.number} – {it.title}</div>
              <div className="text-xs text-muted-foreground">{it.date}</div>
            </div>
            {it.description && <p className="text-sm text-foreground mb-2">{it.description}</p>}
            <ul className="list-disc pl-5 text-sm text-foreground">
              {it.changes?.map((c, idx) => (
                <li key={idx}>{c}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdatesPage;
